import { createContext, useContext } from "react";

// A separate axis from StaticPlotContext (which only disables user interaction for
// minimap/tooltip previews): snapshot restores need interactive charts but must not
// run template side-effects that would overwrite the rehydrated state...
export const AllowSideEffectsContext: React.Context<boolean> = createContext(true);
export const useAllowSideEffects: () => boolean = () => useContext(AllowSideEffectsContext);
